module.exports = __webpack_public_path__ + "static/media/jewelosco.5632eea9.svg";